module.exports = __webpack_public_path__ + "img/mekong-heroes-logo.8fd43c7a.png";